import { render, staticRenderFns } from "./socket-amount.vue?vue&type=template&id=90493b80&"
import script from "./socket-amount.vue?vue&type=script&lang=js&"
export * from "./socket-amount.vue?vue&type=script&lang=js&"
import style0 from "./socket-amount.vue?vue&type=style&index=0&id=90493b80&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports